import { render, staticRenderFns } from "./CommonTag.vue?vue&type=template&id=4475c20a&scoped=true"
import script from "./CommonTag.vue?vue&type=script&lang=js"
export * from "./CommonTag.vue?vue&type=script&lang=js"
import style0 from "./CommonTag.vue?vue&type=style&index=0&id=4475c20a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475c20a",
  null
  
)

export default component.exports